// The page for a URL that matches nothing.
//
// Before this existed the router's `*` route rendered the marketing landing
// page, so squeakbase.com/anything-at-all returned 200 with the homepage on
// it. That is a mistyped link looking like it worked, and — because there is
// no limit on how many such URLs exist — an unbounded set of duplicate pages
// for a crawler to find.
//
// `useNoIndex` is the part that matters for search; the rest is just not
// lying to the reader about where they ended up.
import React from 'react';
import { Link } from 'react-router-dom';
import { useNoIndex } from '../hooks/useNoIndex';

export function NotFound() {
  useNoIndex();

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Page not found</h2>
        <p>
          There is nothing at <code>{window.location.pathname}</code>. It may
          have moved, or the link that brought you here may be incomplete.
        </p>
        {/* A plain anchor, not <Link>: /guides/ is static HTML from
            scripts/build-guides.mjs and is not a route this router knows. */}
        <p>
          Try the <a href="/">home page</a> or the{' '}
          <a href="/guides/">guides</a>.
        </p>
        <Link to="/login" className="auth-link">Sign in</Link>
      </div>
    </div>
  );
}

export default NotFound;
